import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission } from "Actions/commonAction";
import reviewFormConcept from "Assets/Images/career_progress.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isSpaceInString } from "Utils";
import CustomLoader from "Component/CustomLoader";

import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
  },

  drawerPaper: {
    width: "30%",
  },
});
class CompetencyRepository extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unitname: null,
      permissions: { editable: true, readonly: true },
      listdata: [],
      objectiveunitid: null,
      data: false,
      open: false,
      row: null,
      headers: [
        {
          key: "unitname",
          name: "Unit name",
          type: TDTypeConsts.DEPARTMENT_NAME,
          style: { textAlign: "left", fontWeight: "bold", width: "200px" },
        },
        {
          key: "description",
          name: "Description",
          type: TDTypeConsts.DEPARTMENT_DESCRIPTION,
          style: {
            textAlign: "left",
            marginTop: 8,
            marginBottom: 8,
          },
        },
        {
          key: "edit1",
          type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        },
        {
          key: "delete1",
          type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCreate = this.onCreate.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("Successunit");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getObjectiveUnit();
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getObjectiveUnit() {
    this.setState({isLoading:true}, () => {

 
    instance
      .get(`perform/getobjectiveunit`)
      .then((result) => {
        this.setState({
          listdata: result.data.result.map((res) => ({
            ...res,
            hideedit: res.masterobjectiveunitid ? true : false,
            hidedelete: res.masterobjectiveunitid ? true : false,
          })),
          data: true,
          isLoading:false
        });
      })
      .catch((error) => {
        this.setState({
          listdata: [],
          data: true,
          isLoading:false
        });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
  }

  onEdit(row) {
    instance
      .get(`perform/getobjectiveunit/${row.objectiveunitid}`)
      .then((result) => {
        this.setState({
          unitname: result.data.result[0].unitname,
          description: result.data.result[0].description,
          objectiveunitid: result.data.result[0].objectiveunitid,
          open: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onDelete = (item) => {
    instance
      .delete(`perform/deleteobjectiveunit/${item.objectiveunitid}`)
      .then(() => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.getObjectiveUnit();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  handleChange(value, key) {
    this.setState({
      [key]: value,
    });
  }

  onCreate() {
    this.setState({
      open: !this.state.open,
      row: null,
    });
  }

  onSave() {
    const { description, objectiveunitid } = this.state;

    if (this.state.unitname && !isSpaceInString(this.state.unitname)) {
      this.state.unitname = this.state.unitname.trim();
  
    }

    if (this.state.unitname == null) {
      this.props.enqueueSnackbar(" Please  enter Unit Name", {
        variant: "error",
      });
    } else if (description == null) {
      this.props.enqueueSnackbar(" Please  enter description", {
        variant: "error",
      });
    } else {
      instance
        .post(`perform/createobjectiveunit`, {
          objectiveunitid,
          unitname: this.state.unitname,
          description,
        })
        .then((result) => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.setState(
            {
              unitname: null,
              open: false,
              description: null,
              objectiveunitid: null,
            },
            () => {
              this.getObjectiveUnit();
            },
          );
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { listdata, data } = this.state;
    const { classes } = this.props;
    return (
      <div className="innerwrapper-full-width">
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
          
           
              <div className="content-outer-wrapper">
                <Helmet>
                  <title>{headersList.Config.MeasurementUnit.header}</title>
                </Helmet>
                <Grid container>
                  <Grid item md={8} sm={2}>
                    <PageHeader header="Measurement unit" />
                  </Grid>
                  {this.state.permissions && this.state.permissions.editable && (
                    <Grid
                      item
                      md={4}
                      sm={2}
                      justify="flex-end"
                      className="display-flex"
                    >
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        onClick={this.onCreate}
                      >
                        Create
                      </Button>
                    </Grid>
                  )}
                </Grid>
                {this.state.isLoading ? 
                  <CustomLoader/>  
              
            :    <List
                  // onCreate={this.onCreate}
                  list={this.state.listdata}
                  headers={this.state.headers}
                  permissions={false}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  module="competency"
                  showOnlyList
                  // onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
                />
              }
              </div>
          

            {data && listdata.length == 0 && (
              <div className="content-outer-wrapper">
                <CreateComp
                  text="text"
                  heading="Concept of Aptitude focus area"
                  onCreate={this.onCreate}
                  imageSrc={reviewFormConcept}
                  permissions={this.state.permissions}
                />
              </div>
            )}

            <Drawer
              anchor="right"
              open={this.state.open}
              onClose={() =>
                this.setState({
                  unitname: null,
                  open: false,
                  description: null,
                  objectiveunitid: null,
                })
              }
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              <div className="planner-right-drawer">
                <DrawerHeader
                  header="Create new objective unit"
                  isbackarrow={false}
                  closeDrawer={() =>
                    this.setState({
                      unitname: null,
                      open: false,
                      description: null,
                      objectiveunitid: null,
                    })
                  }
                />
                {this.state.open && (
                  <div>
                    <p className="normal-dark-secondary margin-bottom-16">
                      Enter the unit name you wish to create and describe it.
                    </p>

                    <DynamicForm
                      fields={textinputconverter({
                        value: this.state.unitname,
                        placeholder: "",
                        label: "Enter Unit Name",
                      })}
                      onChange={(value) => {
                        this.handleChange(value, "unitname");
                      }}
                    />
                    <DynamicForm
                      className="width50"
                      fields={textareainputconverter({
                        value: this.state.description,
                        label: "Description",
                        placeholder: "Enter description",
                      })}
                      onChange={(value) => {
                        this.handleChange(value, "description");
                      }}
                    />
                    <div
                      style={{
                        position: "relative",
                        bottom: 0,
                        marginBottom: 16,
                      }}
                    >
                      <span className="floatleft">
                        <Button
                          variant="contained"
                          className="btn btn-trans"
                          color="primary"
                          onClick={() =>
                            this.setState({
                              unitname: null,
                              open: false,
                              description: null,
                              objectiveunitid: null,
                            })
                          }
                        >
                          Cancel
                        </Button>
                      </span>

                      {this.state.permissions &&
                        this.state.permissions.editable && (
                          <span className="floatright">
                            <Button
                              variant="contained"
                              className="btn btn-primary-md-blue"
                              color="primary"
                              onClick={this.onSave}
                            >
                              Save
                            </Button>
                          </span>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(CompetencyRepository)));
